import React, { useState } from 'react';

import MembershipForm from "./membership-form";

export default () => {


    return (
        <div className="overlay-memberships">
            <h1>MEMBERSHIPS</h1>
            <form>
                <div className="overlay__content">
                    <MembershipForm />
                </div>
            </form>
        </div>
    )
}
